import React from 'react';

const FieldEditModal = ({ isOpen, onClose, onSave, formData, setFormData, content }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg text-[#333333] font-semibold">{content}</h2>
          <button onClick={onClose} className="text-xl font-bold scale-150">&times;</button>
        </div>

        <div className="w-full border-b border-gray-300 mb-5"></div>

        {/* Form Fields */}
        <div className="gap-5 grid grid-cols-2">
          {/* Label Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Label<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={formData.label}
              onChange={(e) => setFormData({ ...formData, label: e.target.value })}
              placeholder={formData.label}
              className="w-full border rounded-md px-3 py-2"
            />
          </div>

          {/* Type Select */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Type<span className="text-red-500">*</span>
            </label>
            <select
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              className="w-full border rounded-md px-3 py-2"
            >
              <option value="required">Required ( * )</option>
              <option value="optional">Optional</option>
            </select>
          </div>

          {/* Placeholder Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Placeholder<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={formData.placeholder}
              onChange={(e) => setFormData({ ...formData, placeholder: e.target.value })}
              placeholder="Enter Company Name"
              className="w-full border rounded-md px-3 py-2"
            />
          </div>
        </div>

        {/* Save Button */}
        <div className="mt-6 text-right">
          <button
            onClick={onSave}
            disabled={!formData.label || !formData.placeholder}
            className={`px-4 py-2 rounded-md text-white ${
              formData.label && formData.placeholder
                ? 'bg-blue-600 hover:bg-blue-700'
                : 'bg-gray-300 cursor-not-allowed'
            }`}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default FieldEditModal;
